export type ParticipantRole =
  | "owner"
  | "legal_counsel"
  | "approver"
  | "collaborator"
  | "manager"
  | "artist_rep"
  | "label_rep";

export type ParticipantPermission = "full_access" | "edit" | "review";

export const participantRoleLabels: Record<ParticipantRole, string> = {
  owner: "Owner",
  legal_counsel: "Legal Counsel",
  approver: "Approver",
  collaborator: "Collaborator",
  manager: "Manager",
  artist_rep: "Artist Representative",
  label_rep: "Label Representative",
};

export const participantPermissionLabels: Record<ParticipantPermission, string> = {
  full_access: "Full Access",
  edit: "Edit",
  review: "Review Only",
};
